module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp3_9016.9b293c6c.png";